import React, { useState } from 'react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { CustomDateTimePicker } from '../../../../components/datetimepicker';
import { format } from 'date-fns';
import dayjs from 'dayjs';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton } from '@mui/material';
import { DATE_TIME_FORMAT, USER_ROLES } from '../../../../utils/constants';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';

const RescheduleBtn = () => {
    const userInfo = useSelector(state => state.auth.user);
    const { appointmentDetails, setAppointmentDetails } = useAppointmentDetailsContext();
    const [openRescheduleAppt, setOpenRescheduleAppt] = useState(false);
    const [newApptDateTime, setNewApptDateTime] = useState(appointmentDetails?.apptdatetime);

    const toggleReschedule = (toggle = false) => () => {
        setOpenRescheduleAppt(toggle);
    };

    const updateAppointmentTime = async () => {
        const rescheduler = async () => {
            if (userInfo && userInfo.role && userInfo.role === USER_ROLES.DOCTOR) {
                const url = APIUtils.getAdminAPIEndpoint('update-appointment-time');
                const res = await httpClient.post(url, { id: appointmentDetails.id, apptdatetime: newApptDateTime }).then(res => res.data);
                return res;
            }
            const url = APIUtils.getAPIEndpoint('update-appointment-time');
            const res = await httpClient.post(url, { uniqueId: appointmentDetails.uniqueId, apptdatetime: newApptDateTime }).then(res => res.data);
            return res;
        };
        // const url = APIUtils.getAPIEndpoint('update-appointment-time');
        // const res = await httpClient.post(url, { uniqueId: appointmentDetails.uniqueId, apptdatetime: newApptDateTime }).then(res => res.data);
        const res = await rescheduler();
        if (res.status === 'success') {
            Swal.fire('Status!', 'Appointment date & time updated successfully!', 'success');
            setAppointmentDetails(prev => ({...prev, ...res.data}));
            setOpenRescheduleAppt(false);
        } else {
            Swal.fire('Something Went Wrong!', '', 'error');
        }
    };

    const rescheduleUI = openRescheduleAppt && (
        <Dialog open={openRescheduleAppt} maxWidth='xs' fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>Reschedule Appointment</div>
                <IconButton size='small' onClick={toggleReschedule(false)}>
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container className='profile-grid'>
                    <Grid item xs={12}>
                        <CustomDateTimePicker
                            name={'apptdatetime'}
                            value={dayjs(new Date(newApptDateTime))}
                            handleChange={(value) => setNewApptDateTime(format(new Date(value), DATE_TIME_FORMAT))}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' color='secondary' onClick={toggleReschedule(false)}>Cancel</Button>
                <Button variant='contained' color='primary' onClick={updateAppointmentTime}>Submit</Button>
            </DialogActions>
        </Dialog>
    );

    return (
        <>
            {rescheduleUI}
            <Button color="primary" variant="contained" onClick={toggleReschedule(true)}> Reschedule </Button>
        </>
    );
};

export default RescheduleBtn;